import { MAIN_APP_URL } from '../constants'
import { openNotificationWithIcon } from '../utils'
import mixpanel from 'mixpanel-browser'
import { JobTags, removeLocalAndSessionStorage } from '../constants'
import * as JobCycleApi from '../api/jobCycle.api'
import LogRocket from 'logrocket'
import jobCreationBaseFunnelManager from '../funnels/jobCreationBaseFunnel'
import { getGaAttributionIds } from '../utils/gaAttribution'
import { updateJob } from '../api/meeting.api'
/**
 * End meeting
 * @params = ''
 * @response : Will end meeting from both customer and technician
 * @author : Karan
 */
export async function endMeeting(jitsiApi, job, user, socket) {
	try {
		await terminateJitsi(jitsiApi)

		const data = {}
		data['jobId'] = job.id
		data['userType'] = user.userType
		data['email'] = user.email
		data['firstName'] = user.firstName
		data['lastName'] = user.lastName
		data['userId'] = user.id
		data['technicianId'] = job.technician.id

		/*const ga = getGaAttributionIds()
		const gaUpdate = {}
		if (ga.client_id) {
			gaUpdate.client_id = ga.client_id
			data.client_id = ga.client_id
		}
		if (ga.session_id) {
			gaUpdate.session_id = ga.session_id
			data.session_id = ga.session_id
		}
		if (ga.facebook_fbp) {
			gaUpdate.facebook_fbp = ga.facebook_fbp
			data.facebook_fbp = ga.facebook_fbp
		}
		if (ga.facebook_fbc) {
			gaUpdate.facebook_fbc = ga.facebook_fbc
			data.facebook_fbc = ga.facebook_fbc
		}
		if (Object.keys(gaUpdate).length > 0) {
			try {
				await updateJob(job.id, { dataToUpdate: gaUpdate, cuId: user.id })
			} catch (gaErr) {
				console.warn('endMeeting: could not refresh GA attribution on job', gaErr)
			}
		}*/

		//console.log("endMeeting>>>>",data)
		socket.emit('EndMeeting', data)
		// mixpanel code
		mixpanel.identify(user.email)
		mixpanel.track(`${user.userType} - End Meetiing Successfully`, { JobId: job.id })
		// mixpanel code
		let lifeCycleTag = ''
		if (user.userType === 'technician') {
			lifeCycleTag = JobTags.TECHNCIIAN_END_MEETING
		} else {
			lifeCycleTag = JobTags.CUSTOMER_END_MEETING
		}
		if (job.is_transferred && job.is_transferred == true) {
			if (user.userType === 'technician') {
				lifeCycleTag = JobTags.TECHNCIIAN_END_MEETING_AFTER_TRANSFER
			} else {
				lifeCycleTag = JobTags.CUSTOMER_END_MEETING_AFTER_TRANSFER
			}
		}
		await JobCycleApi.create(lifeCycleTag, job.id)
		
		// Track Step 11: Meeting Completed - always track for customer
		// This tracks even if tech ends the meeting, since customer will be redirected to feedback
		if (user.userType === 'customer') {
			try {
				const meetingDuration = calculateMeetingDuration(job);
				const meetingDurationFormatted = formatDuration(meetingDuration);
				const userAgent = navigator.userAgent;
				const deviceType = /Mobile|Android|iPhone/i.test(userAgent) ? 'mobile' : 'desktop';
				
				// Determine who ended the meeting
				const endedBy = user.userType;
				
				// Use the funnel manager to track Step 11
				jobCreationBaseFunnelManager.trackMeetingCompleted({
					user,
					userId: user.id,
					jobId: job.id,
					technicianId: job.technician?.id,
					meetingDuration,
					meetingDurationFormatted,
					endedBy,
					wasSuccessful: true,
					deviceType
				});
				
				console.log('📊 Step 11: Meeting Completed tracked - Customer being redirected to feedback');
			} catch (error) {
				console.error('Error tracking meeting completion:', error);
			}
		}
		
		// This will rest the localStorage for particular field  : usingComputerAudio,customerCallingHimSelf card-modal-open , in-call and meeting-retries etc.
		removeLocalAndSessionStorage(job?.id)
		setTimeout(function () {
			// console.log('Going to redirect page to main app in end meeting.')
			// window.location.href= `/meeting-over/${user.userType}/${job.id}`
			localStorage.removeItem('coBrandingLogoUrl')
			window.location.href = `${MAIN_APP_URL}/meeting-feedback/${job.id}`
		}, 1500)
	} catch (error) {
		// endMeeting(jitsiApi, job, user, socket)
		openNotificationWithIcon('error', 'Error', 'Unable to end meeting. Please reload your page and try again. ' + error)
		console.log('My console for err', error)
	}
}

/**
 * Kickout all partispant from jitsi and terminate
 * @params = ''
 * @response : Will kickout all partispants from jitsi and terminate
 * @author : Karan
 */
export async function terminateJitsi(jitsiApi) {
	if (jitsiApi) {
		jitsiApi.executeCommand('hangup')
		// Try to stop recording (won't error if not recording)
		try {
			if (jitsiApi) {
				jitsiApi.stopRecording('file');
			}
		} catch (error) {
			console.log('No active recording to stop');
		}

		const participants = jitsiApi.getParticipantsInfo()
		for (const p in participants) {
			jitsiApi.executeCommand('kickParticipant', participants[p]['participantId'])
		}
	}
}

/**
 * Calculate meeting duration in seconds
 * @params = job object
 * @response : Returns duration in seconds
 */
function calculateMeetingDuration(job) {
	try {
		if (job.paidStartTime && job.paidEndTime) {
			const start = new Date(job.paidStartTime);
			const end = new Date(job.paidEndTime);
			return Math.floor((end - start) / 1000); // Convert to seconds
		}
		return 0;
	} catch (error) {
		console.error('Error calculating meeting duration:', error);
		return 0;
	}
}

/**
 * Format duration in seconds to MM:SS format
 * @params = duration in seconds
 * @response : Returns formatted string
 */
function formatDuration(seconds) {
	try {
		const mins = Math.floor(seconds / 60);
		const secs = seconds % 60;
		return `${mins}:${secs.toString().padStart(2, '0')}`;
	} catch (error) {
		return '0:00';
	}
}
